/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EmergencyContactDetails } from './EmergencyContactDetails';
import {
    EmergencyContactDetailsFromJSON,
    EmergencyContactDetailsFromJSONTyped,
    EmergencyContactDetailsToJSON,
    EmergencyContactDetailsToJSONTyped,
} from './EmergencyContactDetails';

/**
 * 
 * @export
 * @interface SetEmergencyDetailsRequest
 */
export interface SetEmergencyDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof SetEmergencyDetailsRequest
     */
    shipmentId: string;
    /**
     * 
     * @type {EmergencyContactDetails}
     * @memberof SetEmergencyDetailsRequest
     */
    emergencyDetails: EmergencyContactDetails;
}

/**
 * Check if a given object implements the SetEmergencyDetailsRequest interface.
 */
export function instanceOfSetEmergencyDetailsRequest(value: object): value is SetEmergencyDetailsRequest {
    if (!('shipmentId' in value) || value['shipmentId'] === undefined) return false;
    if (!('emergencyDetails' in value) || value['emergencyDetails'] === undefined) return false;
    return true;
}

export function SetEmergencyDetailsRequestFromJSON(json: any): SetEmergencyDetailsRequest {
    return SetEmergencyDetailsRequestFromJSONTyped(json, false);
}

export function SetEmergencyDetailsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetEmergencyDetailsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'shipmentId': json['shipmentId'],
        'emergencyDetails': EmergencyContactDetailsFromJSON(json['emergencyDetails']),
    };
}

  export function SetEmergencyDetailsRequestToJSON(json: any): SetEmergencyDetailsRequest {
      return SetEmergencyDetailsRequestToJSONTyped(json, false);
  }

  export function SetEmergencyDetailsRequestToJSONTyped(value?: SetEmergencyDetailsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shipmentId': value['shipmentId'],
        'emergencyDetails': EmergencyContactDetailsToJSON(value['emergencyDetails']),
    };
}

